import { gql } from "@apollo/client";

export const CREATE_CANDIDATE = gql`
  mutation CreateCandidate($input: CandidateCreateInput) {
    createCandidate(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const COPY_CANDIDATE = gql`
  mutation CopyCandidate($mandateId: ID!, $partyId: ID!) {
    copyCandidate(mandateId: $mandateId, partyId: $partyId) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_CANDIDATE = gql`
  mutation UpdateCandidate($id: ID!, $input: CandidateUpdateInput) {
    updateCandidate(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_CANDIDATE = gql`
  mutation DeleteCandidate($id: ID!) {
    deleteCandidate(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;
export const GET_NEXT_NUMBER_ORDER_OF_CANDIDATE = gql`
  query Query($partyId: ID, $candidateType: String) {
    getNextNumberOrderOfCandidate(
      partyId: $partyId
      candidateType: $candidateType
    )
  }
`;

export const GET_CANDIDATE_PAGINATION = gql`
  query GetCandidatePagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
    $partyId: String
    $isActive: Boolean
  ) {
    getCandidatePagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
      partyId: $partyId
      isActive: $isActive
    ) {
      data {
        _id
        mandateId {
          mandateName
          _id
        }
        fromParty {
          _id
          partyName
          logo
          remark
          isDefault
        }
        candidateType
        numberOrder
        candidateId {
          latinName
          lastNameKh
          firstNameKh
          gender
          _id
          role
          remark
          profile
          phoneNumber
          nationalIdCardNumber
          dateOfBirth
          email
        }
        isActive
        inactiveRemark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
